/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { AboutPageData } from './AboutPageData'
import {
  AboutPageDataFromJSON,
  AboutPageDataFromJSONTyped,
  AboutPageDataToJSON,
} from './AboutPageData'

/**
 *
 * @export
 * @interface GetAbout200Response
 */
export interface GetAbout200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetAbout200Response
   */
  status: boolean
  /**
   *
   * @type {AboutPageData}
   * @memberof GetAbout200Response
   */
  data: AboutPageData
}

/**
 * Check if a given object implements the GetAbout200Response interface.
 */
export function instanceOfGetAbout200Response(
  value: object
): value is GetAbout200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetAbout200ResponseFromJSON(json: any): GetAbout200Response {
  return GetAbout200ResponseFromJSONTyped(json, false)
}

export function GetAbout200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetAbout200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: AboutPageDataFromJSON(json['data']),
  }
}

export function GetAbout200ResponseToJSON(
  value?: GetAbout200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: AboutPageDataToJSON(value['data']),
  }
}
